import { render, staticRenderFns } from "./DisplayPreferences.vue?vue&type=template&id=4da4bba5&scoped=true"
import script from "./DisplayPreferences.vue?vue&type=script&lang=js"
export * from "./DisplayPreferences.vue?vue&type=script&lang=js"
import style0 from "./DisplayPreferences.vue?vue&type=style&index=0&id=4da4bba5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da4bba5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Generac.Application.MobileLink\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4da4bba5')) {
      api.createRecord('4da4bba5', component.options)
    } else {
      api.reload('4da4bba5', component.options)
    }
    module.hot.accept("./DisplayPreferences.vue?vue&type=template&id=4da4bba5&scoped=true", function () {
      api.rerender('4da4bba5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AccountSettings/DisplayPreferences.vue"
export default component.exports